import "./App.css";

import Header from "./components/Header/Header";
import AllRoutes from "./components/Routes";

function App() {
  return (
    <div className="App">
      <Header />
      <AllRoutes />
  
    </div>
  );
}

export default App;
